/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { LitElement } from 'lit';
import { readoptLitElementStyles } from '../utils/lit-utils';
export class BaseLitElement extends LitElement {
    adoptedCallback() {
        readoptLitElementStyles(this);
    }
}
